import { resultToFailed, resultToSuccess } from '../Helper'
import stockApi from '../StockApi'

export const getLocations = async (fcId) => {
  try {
    const response = await stockApi.get('/localizacoes', {
      params: {
        id_fulfillment_center: fcId
      }
    })
    return resultToSuccess(response)
  } catch (e) {
    return resultToFailed(e)
  }
}
